<template>
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div class="md:bg-white rounded shadow overflow-x-auto">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
